import { FREQUENCY } from "utils/constants";

export const pointsCalculator = (points, frequency) => {
  return points * FREQUENCY[frequency];
};
